// extracted by mini-css-extract-plugin
export default {"alert":"Alert_alert__rdNba","close":"Alert_close__Uzh3K","success":"Alert_success__l2lZl","info":"Alert_info__zGbne","warning":"Alert_warning__EJ8FU"};